import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Outlet, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import SideMenuBox from '@/component/SideMenuBox';
import Header from '@/component/Header';
import useTokenUpdate from '@/utils/useTokenUpdate';

const MainLayout = () => {
  useTokenUpdate();

  const location = useLocation();

  const isSpecialRoute = location.pathname === '/dashboard';

  return (
    <>
      <Wrap className="flex">
        <SideMenuBox />
        <CntBox>
          <Header />
          <Cnt isSpecialRoute={isSpecialRoute}>
            <Outlet />
          </Cnt>
        </CntBox>
      </Wrap>
    </>
  );
};

export default MainLayout;

interface CntProps {
  isSpecialRoute: boolean;
}

const Wrap = styled.div`
  width: 100%;
  min-height: 100vh;
`;

const CntBox = styled.div`
  width: calc(100% - 240px);
  min-height: 100vh;
  @media (max-width: 1420px) {
    width: 100%;
  }
`;

const Cnt = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isSpecialRoute',
})<CntProps>`
  width: 100%;
  height: calc(100% - 72px);
  min-height: calc(100vh - 72px);
  background-color: #f9fbfc;
  box-sizing: border-box;
  padding: 56px;
  @media (max-width: 1420px) {
    height: calc(100% - 60px);
    min-height: calc(100vh - 60px);
    padding: 20px;
  }

  ${({ isSpecialRoute }) =>
    isSpecialRoute &&
    css`
      max-height: calc(100vh - 72px);
      @media (max-width: 1420px) {
        max-height: calc(100vh - 60px);
      }
    `}
`;
